import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '@/contexts/NotificationContext';
import { useDateFormatter } from '@/hooks/useDateFormatter';
import Card from '@/components/atoms/Card';
import Button from '@/components/atoms/Button';
import Icon from '@/components/atoms/Icon/Icon';
import './NotificationsList.scss';

const NotificationsList: React.FC = () => {
  const { t } = useTranslation();
  const { notifications, unreadCount, markAsRead, markAllAsRead, deleteNotification } = useNotifications();
  const { formatRelativeTime } = useDateFormatter();

  return (
    <div className="notifications-list">
      <div className="notifications-list__header">
        <h2 className="notifications-list__title">
          {t('notifications.title')}
          {unreadCount > 0 && <span className="notifications-list__unread-count">({unreadCount})</span>}
        </h2>
        {notifications.length > 0 && (
          <Button variant="outline" size="sm" onClick={() => markAllAsRead()}>
            {t('notifications.markAllRead')}
          </Button>
        )}
      </div>

      {notifications.length === 0 ? (
        <Card variant="elevated">
          <div className="notifications-list__empty">
            <Icon name="campana" size={48} alt={t('notifications.empty')} />
            <p>{t('notifications.empty')}</p>
          </div>
        </Card>
      ) : (
        <div className="notifications-list__items">
          {notifications.map((notification) => (
            <Card
              key={notification.id}
              variant="elevated"
              className={`notifications-list__item ${!notification.read ? 'notifications-list__item--unread' : ''}`}
            >
              <div className="notifications-list__item-header">
                <h4>{notification.title}</h4>
                {!notification.read && <span className="notifications-list__unread-dot" />}
              </div>
              <p className="notifications-list__item-message">{notification.message}</p>
              <div className="notifications-list__item-footer">
                <span className="notifications-list__item-time">{formatRelativeTime(notification.created_at)}</span>
                <div className="notifications-list__item-actions">
                  {!notification.read && (
                    <Button variant="ghost" size="xs" onClick={() => markAsRead(notification.id)}>
                      {t('notifications.markRead')}
                    </Button>
                  )}
                  <Button variant="ghost" size="xs" onClick={() => deleteNotification(notification.id)}>
                    {t('notifications.delete')}
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsList;
